const SafetyIconPowerBreaker = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M14.4938 22.6744C12.8256 24.9306 11.9923 26.0588 11.2147 25.8204C10.4371 25.5819 10.4371 24.1985 10.4371 21.4308V21.1696C10.4371 20.1712 10.4371 19.6725 10.1177 19.3599L10.1009 19.343C9.77483 19.0372 9.25585 19.0372 8.21702 19.0372C6.34664 19.0372 5.41229 19.0372 5.09719 18.4702L5.08118 18.4415C4.78293 17.8661 5.32467 17.1339 6.4073 15.6696L8.98708 12.1773C10.6544 9.92107 11.4885 8.79293 12.2662 9.03136C13.0438 9.2698 13.0438 10.6532 13.0438 13.4209V13.6821C13.0438 14.6805 13.0438 15.1793 13.3631 15.4918L13.38 15.5087C13.706 15.8145 14.225 15.8145 15.2638 15.8145C17.1342 15.8145 18.0686 15.8145 18.3845 16.3815L18.3997 16.4102C18.6979 16.9856 18.1562 17.7186 17.0735 19.1821"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M28.3145 21.1943C28.8544 21.1943 29.3263 21.3014 29.73 21.5154C30.1337 21.7294 30.4451 22.031 30.664 22.4202C30.8877 22.8044 30.9996 23.2495 30.9996 23.7554C30.9996 24.2565 30.8877 24.7016 30.664 25.0907C30.4451 25.4799 30.1313 25.7814 29.7227 25.9955C29.319 26.2095 28.8496 26.3165 28.3145 26.3165H26.3955V21.1943H28.3145ZM28.2342 25.2366C28.7061 25.2366 29.0733 25.1077 29.336 24.8499C29.5987 24.5921 29.73 24.2273 29.73 23.7554C29.73 23.2836 29.5987 22.9163 29.336 22.6537C29.0733 22.391 28.7061 22.2596 28.2342 22.2596H27.6432V25.2366H28.2342Z"
      fill="#171717"
    />
    <path
      d="M20.625 23.7479C20.625 23.242 20.7344 22.7921 20.9533 22.398C21.1722 21.9992 21.4763 21.6903 21.8654 21.4714C22.2594 21.2476 22.7045 21.1357 23.2007 21.1357C23.8087 21.1357 24.3292 21.2963 24.7621 21.6173C25.195 21.9384 25.4845 22.3762 25.6304 22.9307H24.2587C24.1565 22.7167 24.0106 22.5537 23.8209 22.4418C23.636 22.3299 23.4244 22.274 23.1861 22.274C22.8018 22.274 22.4905 22.4078 22.2521 22.6753C22.0138 22.9429 21.8946 23.3004 21.8946 23.7479C21.8946 24.1954 22.0138 24.553 22.2521 24.8205C22.4905 25.0881 22.8018 25.2218 23.1861 25.2218C23.4244 25.2218 23.636 25.1659 23.8209 25.054C24.0106 24.9421 24.1565 24.7792 24.2587 24.5651H25.6304C25.4845 25.1197 25.195 25.5575 24.7621 25.8785C24.3292 26.1947 23.8087 26.3528 23.2007 26.3528C22.7045 26.3528 22.2594 26.2433 21.8654 26.0244C21.4763 25.8007 21.1722 25.4918 20.9533 25.0978C20.7344 24.7038 20.625 24.2538 20.625 23.7479Z"
      fill="#171717"
    />
    <path
      d="M18.6893 26.3165L17.624 24.3829H17.3248V26.3165H16.0771V21.1943H18.1712C18.575 21.1943 18.9179 21.2649 19.2 21.4059C19.487 21.547 19.7011 21.7416 19.8421 21.9897C19.9832 22.2329 20.0537 22.5053 20.0537 22.8069C20.0537 23.1474 19.9564 23.4514 19.7619 23.719C19.5722 23.9865 19.29 24.1762 18.9155 24.2881L20.0975 26.3165H18.6893ZM17.3248 23.5001H18.0983C18.3269 23.5001 18.4972 23.4441 18.609 23.3322C18.7258 23.2204 18.7841 23.0623 18.7841 22.858C18.7841 22.6634 18.7258 22.5102 18.609 22.3983C18.4972 22.2864 18.3269 22.2304 18.0983 22.2304H17.3248V23.5001Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconPowerBreaker
